export default __webpack_public_path__ + "static/media/02.b6a3beb4.jpg";